import { buildClassName } from 'utils/build-class-name';
import styles from './styles.module.scss';
import Button, { SECONDARY_THEME } from 'components/control/button';
import Image from 'next/image';
import Link from 'components/link';
import { ProgramData } from 'tenants';
import { CSSProperties } from 'react';
import { useTranslation } from 'next-i18next';

type MobileProgramCardProps = {
  program: ProgramData;
  index: number;
  onButtonClick?: (index: number) => void;
  style?: CSSProperties | undefined;
};

export default function MobileProgramCard({ program, index, onButtonClick, style }: MobileProgramCardProps) {
  const { t } = useTranslation();
  return (
    <div
      className={buildClassName('mobile-card', styles['mobile-card'])}
      style={style}
    >
      <div className={styles['card-container']}>
        <div className={buildClassName('image-container', styles['image-container'])}>
          <Image src={program.image} alt={`eXp Realty ${t(program.title)} Program`} fill />
        </div>
        <div className={buildClassName('content-container', styles['content-container'])}>
          <div className={styles['card-number']}>{`0${index + 1}`}</div>
          <h3>{t(program.title)}</h3>
          <p>{t(program.description)}</p>
          <Link onClick={() => onButtonClick?.(index)} href={program.buttonLink} target="_blank" rel="noopener noreferrer">
            <Button theme={SECONDARY_THEME} label={t(program.buttonText)} />
          </Link>
        </div>
      </div>
    </div>
  );
}